export default function (props: any) {
    return (
        <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M39.4675 65.1918C42.5701 67.2192 46.2921 68.4 50.2941 68.4C61.1254 68.4 69.9059 59.7502 69.9059 49.08C69.9059 38.4099 61.1254 29.76 50.2941 29.76C46.291 29.76 42.5681 30.9415 39.465 32.9699C37.3176 34.3735 35.467 36.1827 34.0259 38.2865"
                stroke="white"
                strokeWidth="3"
            />
            <path d="M52.0796 11.36H49.0796V22.4H52.0796V11.36Z" fill="white" />
            <path d="M52.0796 75.76H49.0796V86.8H52.0796V75.76Z" fill="white" />
            <path d="M78.1428 23.8787L76.0215 21.7574L68.215 29.5639L70.3363 31.6852L78.1428 23.8787Z" fill="white" />
            <path d="M32.6047 69.4164L30.4834 67.2951L22.6769 75.1015L24.7983 77.2229L32.6047 69.4164Z" fill="white" />
            <path d="M87.7197 51.16V48.16H76.6797V51.16H87.7197Z" fill="white" />
            <path d="M23.3198 51.16V48.16H12.2798V51.16H23.3198Z" fill="white" />
            <path d="M75.2009 77.2229L77.3223 75.1016L69.5158 67.2951L67.3945 69.4164L75.2009 77.2229Z" fill="white" />
            <path d="M29.6633 31.6852L31.7847 29.5639L23.9782 21.7574L21.8569 23.8787L29.6633 31.6852Z" fill="white" />
            <path fillRule="evenodd" clipRule="evenodd" d="M31.7258 42.2703L30.502 35.1898L38.4695 39.7898L31.7258 42.2703Z" fill="white" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M38.8387 40.597L28.9923 56.8699C28.914 56.9993 28.9554 57.1677 29.0848 57.246C29.1346 57.2761 29.1926 57.2895 29.2505 57.2845L35.4534 56.7418L34.3202 68.394C34.3056 68.5445 34.4157 68.6784 34.5663 68.6931C34.6715 68.7033 34.7732 68.6521 34.8276 68.5615L44.5807 52.3178C44.6585 52.1881 44.6165 52.0199 44.4869 51.942C44.4373 51.9123 44.3796 51.899 44.322 51.904L38.3344 52.4278L39.3458 40.7624C39.3589 40.6117 39.2473 40.479 39.0966 40.4659C38.9927 40.4569 38.8927 40.5077 38.8387 40.597Z"
                fill="white"
            />
        </svg>
    );
}
